import { useEffect, useState } from 'react';
import { placesEmportees, type PlaceEmportee } from '../../terrain/places';
import { useSynchronisation } from '../../terrain/useTerrain';
import { Ligne, Liste, Section } from './commun';

export function PlacesEmportees() {
  const [places, setPlaces] = useState<PlaceEmportee[]>([]);
  const sync = useSynchronisation();
  useEffect(() => {
    let actif = true;
    void placesEmportees()
      .then((p) => {
        if (actif) setPlaces(p);
      })
      .catch(() => {
        if (actif) setPlaces([]);
      });
    return () => {
      actif = false;
    };
  }, [sync.revision]);
  if (!places.length) return null;
  return (
    <Section titre="Places de marché emportées">
      <Liste libelle="Places de marché">
        {places.map((p) => (
          <Ligne
            key={p.id}
            href={`/terrain/places/${p.id}`}
            titre={p.reference}
            sousTitre={p.attribution_en_cours?.commercant ?? 'Place libre'}
          />
        ))}
      </Liste>
    </Section>
  );
}
